import CustomError from "@components/Error/CustomError";
import { GADataProps } from "@components/GAData/GAData";
import { useInjectClientData } from "@hooks/useInjectClientData";
import { HttpStatusCode } from "axios";

import SingaporeGe2025Page from "./2025/SingaporeGe2025Page";
import { isSingaporeGe2025Data } from "./utils/helpers";
import { SingaporeGeData } from "./utils/types";

type SingaporeGePageLayoutFactoryProps = {
  data: SingaporeGeData;
};

const SingaporeGePageLayoutFactory = ({
  data,
  gaProps,
}: SingaporeGePageLayoutFactoryProps & {
  gaProps: GADataProps;
}): React.ReactElement => {
  useInjectClientData({ gaProps });

  if (isSingaporeGe2025Data(data)) {
    return <SingaporeGe2025Page {...data} gaProps={gaProps} />;
  }

  return <CustomError statusCode={HttpStatusCode.NotFound} />;
};

export default SingaporeGePageLayoutFactory;
